// src/controls/helpers.ts
var getControlId = (value) => `control-${value.replace(/\s+/g, "-")}`;
var getControlSetterButtonId = (value) => `set-${value.replace(/\s+/g, "-")}`;

export { getControlId, getControlSetterButtonId };
